import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { Linkedin, Instagram, Twitter, Youtube } from "lucide-react";

const cols: { title: string; links: { label: string; to: string }[] }[] = [
  {
    title: "Product",
    links: [
      { label: "Anonymous Feedback", to: "/how-anonymity-works" },
      { label: "AI Insights", to: "/#features" },
      { label: "Action Plans", to: "/#features" },
      { label: "Pulse Campaigns", to: "/#features" },
      { label: "Pricing", to: "/pricing" },
      { label: "Track Feedback", to: "/track" },
    ],
  },
  {
    title: "Use Cases",
    links: [
      { label: "HR Teams", to: "/solutions/hr-teams" },
      { label: "Remote Teams", to: "/solutions/remote-teams" },
      { label: "Enterprise", to: "/solutions/enterprise" },
      { label: "Startups", to: "/solutions/startups" },
      { label: "Culture Building", to: "/solutions/culture-building" },
      { label: "Retention", to: "/solutions/employee-retention" },
    ],
  },
  {
    title: "Compare",
    links: [
      { label: "vs Culture Amp", to: "/compare/culture-amp-alternative" },
      { label: "vs SurveyMonkey", to: "/compare/surveymonkey-alternative" },
      { label: "vs Traditional Surveys", to: "/compare/traditional-surveys" },
      { label: "Why Anonymous?", to: "/compare/why-anonymous-feedback" },
      { label: "Anonymous Email", to: "/compare/anonymous-email" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Help Center", to: "/help" },
      { label: "About", to: "/about" },
      { label: "Contact", to: "/contact" },
      { label: "API Docs", to: "/api-docs" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "Privacy Policy", to: "/privacy-policy" },
      { label: "Terms of Service", to: "/terms-of-service" },
      { label: "Refund Policy", to: "/refund-policy" },
      { label: "Cookie Policy", to: "/cookie-policy" },
    ],
  },
];

export const MarketingFooter = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-card border-t border-border">
      {/* Decorative gradient strip */}
      <div className="h-2 mkt-gradient-hero" />
      <div className="container mx-auto px-4 lg:px-8 py-16 lg:py-20">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-10">
          <div className="col-span-2 md:col-span-3 lg:col-span-1">
            <Logo size="md" />
            <p className="mt-4 text-sm text-muted-foreground max-w-xs">
              Honest employee feedback, built for HR teams that actually act on it.
            </p>
          </div>
          {cols.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-bold text-foreground mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label + l.to}>
                    <Link
                      to={l.to}
                      className="text-sm text-muted-foreground hover:text-foreground transition"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-muted-foreground">
            © {year} SendFeedback.ai — All rights reserved.
          </p>
          <div className="flex items-center gap-2">
            {[
              { Icon: Twitter, href: "https://x.com/sendfeedback", label: "Twitter" },
              { Icon: Linkedin, href: "https://www.linkedin.com/company/sendfeedback/", label: "LinkedIn" },
              { Icon: Instagram, href: "https://www.instagram.com/sendfeedback.ai", label: "Instagram" },
              { Icon: Youtube, href: "https://youtube.com", label: "YouTube" },
            ].map(({ Icon, href, label }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="h-9 w-9 inline-flex items-center justify-center rounded-full text-muted-foreground hover:text-foreground hover:bg-muted transition"
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};
